<template>
  <div class="homework-list">
    <div class="homework-header">
      <el-button type="primary" @click="handleJump('newHomework')"
        >{{ $t("homeworkManage.newHomework")
        }}<i class="el-icon-circle-plus el-icon--right"></i
      ></el-button>
    </div>
    <div class="homework-table">
      <el-table
        height="100%"
        :data="homeworkList"
        border
        header-row-class-name="customHeader"
      >
        <el-table-column
          align="center"
          :label="$t('projectV2.index')"
          type="index"
          width="60"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('jobManagementV2.jobName')"
          min-width="120"
          class-name="homework-name"
          :resizable="false"
        >
          <template slot-scope="{ row }"
            ><span @click="handleDetail(row)">{{
              row.projectName
            }}</span></template
          >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('common.creationTime')"
          prop="createTime"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('newProjectV2.langPair')"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <template v-if="$i18n.locale === 'zh'">{{
              row.langDesc.replace(">", " — ")
            }}</template>
            <template v-else
              >{{ $langCase[row.sourceLang] }} —
              {{ $langCase[row.targetLang] }}</template
            >
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('newProjectV2.domain')"
          :resizable="false"
        >
          <template slot-scope="{ row }">{{
            $i18n.locale === "zh" ? row.domainName : $domainCase[row.domainCode]
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('homeworkManage.class')"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <el-tooltip
              effect="dark"
              popper-class="class-list-tooltip"
              :disabled="showTitle"
              :content="
                row.classList.length > 0
                  ? row.classList.map((item) => item.name).join('、')
                  : '--'
              "
              placement="top"
            >
              <div class="class-list" @mouseover="classListMouseover($event)">
                {{
                  row.classList.length > 0
                    ? row.classList.map((item) => item.name).join("、")
                    : "--"
                }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('homeworkManage.completeSituation')"
          :width="$i18n.locale === 'zh' ? '100' : '160'"
          :resizable="false"
        >
          <template slot-scope="{ row }">{{
            row.unFinishTaskNumber + row.finishTaskNumber === 0
              ? "--"
              : `${row.finishTaskNumber}/${
                  row.unFinishTaskNumber + row.finishTaskNumber
                }`
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          :label="$t('projectDetailsV2.status')"
          :width="$i18n.locale === 'zh' ? '100' : '160'"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <span :class="`homework-status status-${statusFormat(row, 1)}`">{{
              statusFormat(row, 2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="operate"
          show-overflow-tooltip
          align="center"
          :label="$t('newProjectV2.operate')"
          width="230"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <el-tooltip
              effect="dark"
              :content="$t('projectDetailsV2.distribution')"
              placement="top"
            >
              <i
                class="icon-assign"
                @click="handleAssign(row)"
                v-if="statusFormat(row, 1) === 1"
              ></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="$t('jobManagementV2.myHomework')"
              placement="top"
            >
              <i class="icon-view" @click="handleDetail(row)"></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="$t('homeworkManage.cancelJob')"
              placement="top"
            >
              <i
                class="icon-cancel"
                @click="handleCancel(row)"
                v-if="statusFormat(row, 1) === 2"
              ></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="$t('jobManagementV2.downloadReport')"
              placement="top"
            >
              <i
                class="icon-download"
                @click="handleDownloadReport(row)"
                v-if="statusFormat(row, 1) === 3"
              ></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="$t('common.del')"
              placement="top"
            >
              <i class="icon-delete" @click="handleDelete(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="homework-pagination">
      <el-pagination
        background
        layout="prev, pager, next, sizes"
        :pager-count="5"
        :current-page="query.page"
        :page-sizes="[20, 30, 40]"
        :page-size="query.rows"
        :total="totalRows"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <assign-homework
      ref="assignHomework"
      :dialogVisible="assignVisible"
      @handleClose="handleAssignClose"
      @update="getHomeworkList"
      @addClass="addClass"
      :globalObj="globalObj"
    ></assign-homework>
    <base-dialog
      :dialogVisible="deleteVisible"
      @handleConfirm="handleDeleteConfirm"
      @handleClose="handleDeleteClose"
      ><div class="delete-content">
        {{ $t("jobManagementV2.deleteOperation") }}
      </div></base-dialog
    >
    <base-dialog
      :dialogVisible="cancelVisible"
      @handleConfirm="handleCancelConfirm"
      @handleClose="handleCancelClose"
      ><div class="delete-content">
        {{ $t("homeworkManage.cancelOperation") }}
      </div></base-dialog
    >
    <async-download-file
      :isDownloadLoading="isDownloadLoading"
      :asyncDownloadFun="asyncDownloadFun"
      @handleClose="handleDownloadClose"
    ></async-download-file>
    <!-- 添加班级 -->
    <addclass-dialog
      :addclassVisible="addclassVisible"
      @handlerclassClose="handlerclassClose"
      @handlerclassSuccess="handlerclassSuccess"
    >
    </addclass-dialog>
    <NewAssignHomework
      :globalObj="globalObj"
      :assignHomeworkVisible="assignHomeworkVisible"
      @handleAssignClose="handleAssignClose"
      @update="getHomeworkList"
    >
    </NewAssignHomework>
  </div>
</template>

<script>
import { deleteProject } from "@/services/myProjectApi";
import {
  cancelJob,
  queryFilePage,
  downloadHomeworkReport,
} from "@/services/jobManagement";
import addclassDialog from "./components/addclassDialog/addClassDialog.vue";
import BaseDialog from "@/components/delDialog";
import AssignHomework from "./components/assign-homework";
import AsyncDownloadFile from "@/components/async-download-file";
import NewAssignHomework from "./components/new-assign-homework";
import { mapState } from "vuex";

export default {
  name: "HomeworkList",
  beforeRouteEnter(to, from, next) {
    if (from.name == null) {
      console.log("刷新进入");
      next((vm) => {
        vm.isRefushGoing = true;
      });
    } else {
      next((vm) => {
        vm.isRefushGoing = false;
      });
    }
  },
  components: {
    BaseDialog,
    AssignHomework,
    AsyncDownloadFile,
    addclassDialog,
    NewAssignHomework,
  },
  data() {
    return {
      query: {
        filter: {
          sourceType: 1,
        },
        page: 1,
        rows: 20,
        sort: {
          create_time: "desc",
        },
      },
      homeworkList: [],
      totalRows: 0,
      assignVisible: false, // 分配
      globalObj: {},
      deleteVisible: false, // 删除
      isDownloadLoading: false, // 下载
      asyncDownloadFun: () => {}, // 异步下载
      cancelVisible: false, // 取消作业
      showTitle: true,
      addclassVisible: false,
      assignHomeworkVisible: false, // 新的分配作业
      isRefushGoing: false, //刷新进入

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
        .code,
    };
  },
  computed: {
    ...mapState({
      navInfo: (state) => state.layout.navInfo,
      isRouteDataReady: (state) => state.layout.isRouteDataReady,
    }),
  },
  watch: {
    navInfo: {
      deep: true,
      handler(newVal, oldVal) {
        let flag = newVal.find((item) => item.code == "job_manage");
        if (!flag && this.isRouteDataReady && this.isRefushGoing) {
          this.isRefushGoing = false
          let url = "/home/intelligentTranslation/textTranslation";
          this.$router.replace({ path: url });
        }
      },
    },
  },
  mounted() {
    this.getHomeworkList();
  },
  methods: {
    handleAssign(row) {
      this.globalObj = { ...row };
      // this.assignVisible = true;
      this.assignHomeworkVisible = true;
    },
    handleAssignClose() {
      this.globalObj = {};
      // this.assignVisible = false;
      this.assignHomeworkVisible = false;
    },
    handleDelete(row) {
      this.globalObj = { ...row };
      this.deleteVisible = true;
    },
    async handleDeleteConfirm() {
      let { success } = await deleteProject({
        id: this.globalObj.projectId,
        companyCode: this.companyCode,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t("projectV2.success"));
        if (this.query.page > 1 && this.homeworkList.length === 1) {
          this.query.page--;
        }
        this.getHomeworkList();
        this.handleDeleteClose();
      }
    },
    handleDeleteClose() {
      this.globalObj = {};
      this.deleteVisible = false;
    },
    handleDetail(row) {
      this.$router.push({
        name: "homeworkDetail",
        query: {
          key: this.$Base64.encode(
            JSON.stringify({
              id: row.id,
            })
          ),
        },
      });
    },
    handleDownloadReport(row) {
      this.asyncDownloadFun = () =>
        downloadHomeworkReport({
          projectId: row.projectId,
          companyCode: this.companyCode,
        });
      this.isDownloadLoading = true;
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => {};
      this.isDownloadLoading = false;
    },
    handleCancel(row) {
      this.globalObj = { ...row };
      this.cancelVisible = true;
    },
    async handleCancelConfirm() {
      let { success } = await cancelJob({
        fileId: this.globalObj.id,
        projectId: this.globalObj.projectId,
        companyCode: this.companyCode,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t("homeworkManage.cancelSuccessful"));
        this.getHomeworkList();
        this.handleCancelClose();
      }
    },
    handleCancelClose() {
      this.globalObj = {};
      this.cancelVisible = false;
    },
    async getHomeworkList() {
      this.query.filter.companyCode = this.companyCode;
      let { success, list, totalRows } = await queryFilePage(this.query);
      if (success) {
        this.homeworkList = list;
        this.totalRows = totalRows;
      }
    },
    handleSizeChange(val) {
      this.query.rows = val;
      this.getHomeworkList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getHomeworkList();
    },
    handleJump(name) {
      this.$router.push({ name });
    },
    statusFormat(row, type) {
      let total = row.unFinishTaskNumber + row.finishTaskNumber;
      if (total === 0) {
        return type === 1 ? 1 : this.$t("assignTaskV2.notAssign");
      } else {
        if (row.finishTaskNumber === total) {
          return type === 1 ? 3 : this.$t("assignTaskV2.completed");
        }
        return type === 1 ? 2 : this.$t("assignTaskV2.haveAssign");
      }
    },
    classListMouseover(e) {
      let target = e.target;
      let textLength = target.clientWidth;
      let containerLength = target.scrollWidth;
      this.showTitle = textLength === containerLength ? true : false;
    },
    //添加班级
    addClass() {
      this.addclassVisible = true;
    },
    //关闭添加班级
    handlerclassClose() {
      this.addclassVisible = false;
    },
    //添加班级成功
    handlerclassSuccess() {
      this.addclassVisible = false;
      //更新班级列表
      this.$refs.assignHomework.getClassList();
    },
  },
};
</script>

<style lang="less" scoped>
.homework-list {
  line-height: 1.5;
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.homework-header {
  height: 32px;
  display: flex;
  justify-content: space-between;
  .el-button {
    height: 32px;
    padding: 0 15px;
    /deep/ span {
      display: inline-block;
      height: 32px;
      line-height: 30px;
    }
  }
}
.homework-table {
  margin-top: 15px;
  height: calc(100% - 32px - 32px - 15px - 15px);
  /deep/.el-table__body-wrapper .cell {
    color: #666;
  }
  /deep/.customHeader {
    th {
      background: #f3f7fe;
      color: #566087;
      font-weight: bold;
    }
  }
  /deep/.homework-name {
    .cell.el-tooltip {
      text-align: left;
      color: #0078fc;
      span {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .class-list {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .homework-status {
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    display: inline-block;
    border-radius: 2px;
  }
  .status-1 {
    background: rgba(255, 164, 59, 0.08);
    color: rgba(255, 164, 59, 1);
  }
  .status-2 {
    background: rgba(0, 120, 252, 0.08);
    color: rgba(0, 120, 252, 1);
  }
  .status-3 {
    background: rgba(35, 195, 67, 0.08);
    color: rgba(35, 195, 67, 1);
  }
  /deep/.operate {
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    i {
      display: inline-block;
      width: 17px;
      height: 18px;
      cursor: pointer;
    }
    i + i {
      margin-left: 20px;
    }
    .icon-assign {
      background: url("~@/assets/imgs/homework/operation_icon_distribution_nor.png")
        no-repeat center center/17px 16px;
    }
    .icon-assign:hover {
      background: url("~@/assets/imgs/homework/operatio_icon_distribution_pre.png")
        no-repeat center center/17px 16px;
    }
    .icon-view {
      background: url("~@/assets/imgs/homework/icon-view.png") no-repeat center
        center/17px 18px;
    }
    .icon-view:hover {
      background: url("~@/assets/imgs/homework/icon-view-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-cancel {
      background: url("~@/assets/imgs/homework/icon-cancel.png") no-repeat
        center center/17px 18px;
    }
    .icon-cancel:hover {
      background: url("~@/assets/imgs/homework/icon-cancel-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-download {
      background: url("~@/assets/imgs/homework/icon-report.png") no-repeat
        center center/17px 18px;
    }
    .icon-download:hover {
      background: url("~@/assets/imgs/homework/icon-report-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-delete {
      background: url("~@/assets/imgs/homework/icon-del.png") no-repeat center
        center/17px 18px;
    }
    .icon-delete:hover {
      background: url("~@/assets/imgs/homework/icon-del-pre.png") no-repeat
        center center/17px 18px;
    }
  }
}
.homework-pagination {
  text-align: center;
  margin-top: 15px;
  height: 32px;
  line-height: 32px;
  /deep/.btn-prev {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.number {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-icon-more {
    background: #ffffff;
  }
  /deep/.btn-next {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-pagination__sizes {
    margin-right: -10px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid #0087fc;
    border-radius: 4px;
    background: #ffffff;
    color: #0078fc;
  }
  /deep/.el-pagination.is-background .el-pager li {
    background: #ffffff;
  }
}
</style>
<style lang="less">
.class-list-tooltip {
  max-width: 30%;
}
</style>